import { render, staticRenderFns } from "./StatsPhoenixDeviceDetails.vue?vue&type=template&id=8bc55664&"
import script from "./StatsPhoenixDeviceDetails.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenixDeviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenixDeviceDetails.vue?vue&type=style&index=0&id=8bc55664&prod&lang=scss&"
import style1 from "./StatsPhoenixDeviceDetails.vue?vue&type=style&index=1&id=8bc55664&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports